import styles from './list.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX } from '@awesome.me/kit-012d1b9af0/icons/classic/regular';

export default function ErrorFetching() {
	return (
		<div className={styles['error-fetching']}>
			<FontAwesomeIcon icon={faX} size='lg' /> Something Went Wrong Please
			Refresh the Page.
			<br />
			If Persist Please Contact Us
		</div>
	);
}
